
export const BOLD_ON = "<b>"
export const BOLD_OFF = "<b>"
export const CENTER = "COMMANDS.TEXT_FORMAT.TXT_ALIGN_CT;"
export const LEFT = "COMMANDS.TEXT_FORMAT.TXT_ALIGN_LT;"
export const RIGHT = "COMMANDS.TEXT_FORMAT.TXT_ALIGN_RT;"
export const FONT_L = "COMMANDS.TEXT_FORMAT.TXT_FONT_A;"
export const FONT_M = "COMMANDS.TEXT_FORMAT.TXT_FONT_B;"
export const FONT_S = "COMMANDS.TEXT_FORMAT.TXT_FONT_C;"
export const HR2 = "************************"
export const printerList: Record<string, any> = {
    
};

export interface SelectedPrinter {
    device_name: string;
    inner_mac_address: string;
    printerType: string;
}

export const getListDevices = async (selectedPrinterType: string) => {
    return [];
};

export const printToPrinter = async (selectedPrinter: SelectedPrinter, receipt: boolean, dataURL: string, document: string) => {
    return;
};